import { GET_PATIENT_MICROSCOPIC_LINK } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const getPatientMicroscopyData = createAsyncThunk('getPatientMicroscopyData', async (formData:FormData) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = GET_PATIENT_MICROSCOPIC_LINK
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default getPatientMicroscopyData;
